import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { racingProfileLink } from 'modules/HorseRacing/utils';

import { LocalFullDate } from 'modules/Common/components/LocalDateTime';
import HorseSummaryElement from './HorseSummaryElement';

import { HORSE_SEXES } from 'modules/HorseRacing/consts';

export default class HorseProfileDetails extends PureComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired
  };

  render() {
    const {
      profile: {
        age,
        foaled,
        sex: {
          type: sexCode
        } = {},
        trainer: {
          name: trainerName,
          business_reference: {
            id: trainerId
          } = {}
        } = {},
        sire: {
          name: sireName
        } = {},
        dam: {
          name: damName
        } = {},
        owner
      } = {}
    } = this.props;

    const {[sexCode]: sex = "?"} = HORSE_SEXES;

    return (
      <ul className="horse-profile-summary">
        { age && foaled && <HorseSummaryElement label="Age">{age} (Foaled <LocalFullDate iso={new Date(foaled)}/>)</HorseSummaryElement> }
        { trainerName && trainerId && <HorseSummaryElement link={racingProfileLink('trainer', trainerId)} label="Trainer">{trainerName}</HorseSummaryElement> }
        { sex && <HorseSummaryElement label="Sex">{sex}</HorseSummaryElement> }
        { sireName && <HorseSummaryElement label="Sire">{sireName}</HorseSummaryElement> }
        { damName && <HorseSummaryElement label="Dam">{damName}</HorseSummaryElement> }
        { owner && <HorseSummaryElement label="Owner">{owner}</HorseSummaryElement> }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/HorseProfileDetails.js